import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from '../../forms/FormMixin'
import { useRoute } from 'vue-router'
import { storage } from '@/utils/session'
import useField from '@/composables/useField'
import { useUserStore } from '@/stores/user'
  import {
    emailSendOtpResource,
    emailConfirmResource,
  } from '@/services/profile.service'
  
import useGlobal from '@/composables/useGlobal'


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailConfirmModal',
  emits: ['changeForm'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  
  
const emit = __emit
const { $t } = useGlobal()
const load = ref(false) 
const dataIsSended = ref(false)
const nonFieldErrors = ref("")
const otp = ref(null)

const optIsSended = ref(false)

const form = ref({
  otp: null,
})

const store = useUserStore()
const storeRefresher = computed(() => useUserStore())

const fields = ref([
  useField('otp', $t("Code")),
])

const request = (sendData: any, control: any) => {
  useSubmit( send(sendData, control), control)
}

const sendOtp = async (reSend = false) => {
  try {
      if(reSend) optIsSended.value = true
      await emailSendOtpResource.execute({})
      if(reSend) setTimeout(() => {
        optIsSended.value = false
      }, 60000);
  } catch (e) {
    return Promise.reject(e)
  }
}

const send = async (sendData: any, control: any) => {
  try {
      load.value = true
      await emailConfirmResource.execute({}, {
        ...sendData,
      })
      dataIsSended.value = true
      await storeRefresher.value.getUserData()
      load.value = false
  } catch (e) {
    load.value = false
    return Promise.reject(e)
  }
}

sendOtp()
  
const __returned__ = { emit, $t, load, dataIsSended, nonFieldErrors, otp, optIsSended, form, store, storeRefresher, fields, request, sendOtp, send, ref, computed, get useSubmit() { return useSubmit }, get useRoute() { return useRoute }, get storage() { return storage }, get useField() { return useField }, get useUserStore() { return useUserStore }, get emailSendOtpResource() { return emailSendOtpResource }, get emailConfirmResource() { return emailConfirmResource }, get useGlobal() { return useGlobal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})